"use client";

import Link from "next/link";
import Image from "next/image";
import { useAuth } from "@/contexts/auth-context";
import { Button } from "@/components/ui/button";
import { LanguageSelector } from "@/components/ui/language-selector";
import { useTranslation } from "react-i18next";
import { usePathname } from "next/navigation";
import { ChatIcon, SearchIcon, PortfolioIcon, UserIcon } from "@/components/icons";
import { useChatContext } from "@/contexts/ChatContext";
import { useIsMobile } from "@/hooks/use-mobile";

function ChatSidebarToggle() {
  const { isSidebarOpen, openSidebar, chatSessions } = useChatContext();
  const isMobile = useIsMobile();

  const showOpenToggle = isMobile && !isSidebarOpen && chatSessions.length > 0;

  if (!showOpenToggle) {
    return null;
  }

  const handleClick = () => {
    openSidebar();
  };

  return (
    <button
      onClick={handleClick}
      className="flex h-7 w-7 items-center justify-center rounded-lg text-neutral-400 hover:text-white transition-colors"
      title="Open sidebar"
    >
      <Image
        src="/images/notes_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg"
        alt="Open sidebar"
        width={18}
        height={18}
      />
    </button>
  );
}

export function MobileNav() {
  const { t } = useTranslation();
  const { user, signOut } = useAuth();
  const pathname = usePathname() ?? '';

  const navLinks = [
    { href: "/chat", label: t('nav.chat'), icon: ChatIcon },
    // { href: "/search", label: t('nav.search'), icon: SearchIcon },
    // { href: "/portfolio", label: t('nav.portfolio'), icon: PortfolioIcon },
    { href: "/account", label: t('nav.account'), icon: UserIcon },
  ];

  const isChatRoute = pathname.startsWith('/chat');

  return (
    <header className="fixed top-0 left-0 right-0 z-40 flex h-14 items-center gap-4 bg-background px-4 md:hidden border-b border-border">
      {isChatRoute ? (
        <ChatSidebarToggle />
      ) : (
        <Link href="/" className="flex items-center">
          <Image src="/favicon.ico" alt="Lema Logo" width={28} height={28} className="h-7 w-7" />
        </Link>
      )}
      <div className="flex-1" />
      <nav className="flex items-center space-x-4">
        {navLinks.map(link => {
          const Icon = link.icon;
          const iconClassName = link.href === "/search" ? "h-6 w-6" : "h-5 w-5";
          return (
            <Link
              key={link.href}
              href={link.href}
              className={`flex items-center justify-center h-9 w-9 rounded-lg transition-all ${
                pathname.startsWith(link.href)
                  ? "text-primary bg-muted"
                  : "text-muted-foreground hover:text-primary"
              }`}
            >
              <Icon className={iconClassName} />
            </Link>
          );
        })}
      </nav>
    </header>
  );}
